import { api } from "../client";
import { Config, ConfigMutate } from "../types";
import {
  MessageExtraFields,
  MessageFields,
  PartialMessageExtraFields,
  PartialMessageFields,
} from "../schema";

type ApiRequestConfig = Config<MessageFields, MessageExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialMessageFields,
  PartialMessageExtraFields
>;

export const getMessages = (config?: ApiRequestConfig) => {
  return api.get<MessageFields, MessageExtraFields>(`messages`, config);
};

export const getMessage = (id: number, config?: ApiRequestConfig) => {
  return api.get<MessageFields, MessageExtraFields>(`messages/${id}`, config);
};

export const createMessage = (config?: ApiRequestConfigMutate) => {
  return api.create<MessageFields, MessageExtraFields>(`messages`, config);
};

export const updateMessage = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<MessageFields, MessageExtraFields>(
    `messages/${id}`,
    config
  );
};

export const deleteMessage = (id: number) => {
  return api.remove<MessageFields, MessageExtraFields>(`messages/${id}`);
};
